import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

// material-ui components
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';


import Divider from '@material-ui/core/Divider';

import TabBar from './TabBar';

import { patchProject, selectProject, saveProject } from '../modules/project';

import { requestProjectRemove } from '../modules/projects';

 import { cloneCalculation, requestCalculationRemove, requestCalculationRename } from '../modules/calculation';

import { pdfCreateRequest, openSetting } from '../modules/app';

import { openDialog, PROJECT_DETAILS_DIALOG, CREATE_NEW_PROJECT_DIALOG, PROJECT_SAVE_DIALOG } from '../modules/dialogs';

import { getUIText } from '../utils/index';

const NEW_PROJECT = 'NEW_PROJECT';
const SELECT_PROJECT = 'SELECT_PROJECT';
const PRINT_PDF = 'PRINT_PDF';
const SETTINGS = 'SETTINGS';
const CLONE = 'CLONE';
const DELETE_CALCULATION = 'DELETE_CALCULATION';
const RENAME_CALCULATION = 'RENAME_CALCULATION';
const PROJECT_CREATE_NEW = 'PROJECT_CREATE_NEW';
const PROJECT_EDIT_DETAILS = 'PROJECT_EDIT_DETAILS';
const PROJECT_REMOVE_REQUEST = 'PROJECT_REMOVE_REQUEST';

const ITEM_HEIGHT = 48;

const options = [
  {id: PRINT_PDF, languageId: 'MENU-SAVE_AS_PDF'},
  {id: CLONE, languageId: 'CALCULATION-CLONE'},
//  {id:CLONE, languageId:"GENERAL-CLONE_CALCULATION"},
  {id: RENAME_CALCULATION, languageId: 'RENAME_CALCULATION'},
  {id: DELETE_CALCULATION, languageId: 'DELETE_CALCULATION'},
  {id: PROJECT_CREATE_NEW, languageId: 'PROJECTS-CREATE_NEW_PROJECT'},
  {id: PROJECT_EDIT_DETAILS, languageId: 'PROJECT_EDIT_DETAILS'},
  {id: PROJECT_REMOVE_REQUEST, languageId: 'PROJECT_REMOVE_REQUEST'},
  {id: SETTINGS, languageId: 'SETTINGS-TITLE'},
];

class NavBar extends Component {

  state = {
    anchorEl: undefined,
    open: false,
    anchorEl2: undefined,
    open2: false,
    value3: 1
  };

  componentDidUpdate(_, prevState) {
    if (this.state.open && !prevState.open) {
      setTimeout(() => {
        if (this.state.open) {
          document.addEventListener('mousedown', this.handleProjectMenuClickOutside);
        }
      }, 0);
    } else if (!this.state.open && prevState.open) {
      document.removeEventListener('mousedown', this.handleProjectMenuClickOutside);
    }

    if (this.state.open2 && !prevState.open2) {
      setTimeout(() => {
        if (this.state.open2) {
          document.addEventListener('mousedown', this.handleActionMenuClickOutside);
        }
      }, 0);
    } else if (!this.state.open2 && prevState.open2) {
      document.removeEventListener('mousedown', this.handleActionMenuClickOutside);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleProjectMenuClickOutside);
    document.removeEventListener('mousedown', this.handleActionMenuClickOutside);
  }

  handleClick = event => {
    event.stopPropagation();
    const menuEl = document.getElementById('project-menu');
    if (menuEl && menuEl.contains(event.target)) {
      return;
    }
    if (this.state.open) {
      this.handleRequestClose();
    } else {
      this.setState({ open: true, anchorEl: event.currentTarget });
    }
  };

  handleRequestClose = () => {
    this.setState({ open: false, anchorEl: undefined });
  };

  handleProjectMenuClickOutside = (event) => {
    const { anchorEl } = this.state;
    const menuEl = document.getElementById('project-menu');

    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    if (menuEl && menuEl.contains(event.target)) {
      return;
    }

    this.handleRequestClose();
  };

  handleProjectMenuItemClick = (data, item) => (event) => {
    event.stopPropagation();
    this.setState({ open: false, anchorEl: undefined }, () => {
      this.handleProjectMenuAction(data, item);
    });
  };

  handleProjectMenuAction = (data, item) => {
    const {
      project,

      selectProject,
      openSaveProjectDialog,
    } = this.props;

    if (!item) {
      return;
    }

    switch (item) {
      case NEW_PROJECT:
        if (project.unsaved) {
          openSaveProjectDialog();
        } else if (this.props && this.props.onOpenProjectDetails) {
          this.props.openCreateNewProjectDialog();
        }
        break;

      case SELECT_PROJECT:
        if (!data || data.id === project.id) {
          return;
        }

        if (project.unsaved) {
          openSaveProjectDialog(data.id);
        } else if (data && data.hasOwnProperty('id')) {
          selectProject({ id: data.id });
        }
        break;

      default:

    }
  };

  handleClick2 = event => {
    event.stopPropagation();
    if (this.state.open2) {
      this.handleRequestClose2();
    } else {
      this.setState({ open2: true, anchorEl2: event.currentTarget });
    }
  };

  handleRequestClose2 = () => {
    this.setState({ open2: false, anchorEl2: undefined });
  };

  handleActionMenuClickOutside = (event) => {
    const { anchorEl2 } = this.state;
    const menuEl = document.getElementById('long-menu');

    if (anchorEl2 && anchorEl2.contains(event.target)) {
      return;
    }
    if (menuEl && menuEl.contains(event.target)) {
      return;
    }

    this.handleRequestClose2();
  };

  handleActionMenuItemClick = (id) => (event) => {
    event.stopPropagation();
    this.handleRequestClose2();
    this.handleActionMenuAction(id);
  };

  handleActionMenuAction = (id) => {
    if (!id) {
      return;
    }
    switch (id) {
      case PRINT_PDF:
        if(this.props && this.props.createPDF) {
          this.props.createPDF();
        }
        break;

      case SETTINGS:
        if(this.props && this.props.history) {
          this.props.openSetting();
        }
        break;

      case CLONE:
        if(this.props && this.props.cloneCalculation) {
          this.props.cloneCalculation();
        }
        break;

      case DELETE_CALCULATION:
        if(this.props && this.props.onCalculationRemove) {
          this.props.onCalculationRemove();
        }
        break;

      case RENAME_CALCULATION:
        if(this.props && this.props.onCalculatioRename) {
          this.props.onCalculatioRename();
        }
        break;

      case PROJECT_CREATE_NEW:
        if(this.props && this.props.onOpenProjectDetails) {
          this.props.openCreateNewProjectDialog();
        }
        break;

      case PROJECT_EDIT_DETAILS:
        if(this.props && this.props.onOpenProjectDetails) {
          this.props.onOpenProjectDetails();
        }
        break;

      case PROJECT_REMOVE_REQUEST:
        if(this.props && this.props.onRequestProjectRemove) {
          this.props.onRequestProjectRemove();
        }
        break;

      default:

    }
  };

  handleChange3 = (event, value3) => {
    this.setState({ value3 });
  };

  render() {
    const {
      projects,
      project,
      onProjectNameChange,
      onCalculationIndexChange,
      translations,
      app,
      user,

      saveProject
    } = this.props;

    let selectedProjectName = <label style={{fontStyle: 'normal'}}>{project.title}</label>;
    if(project.unsaved) {
      selectedProjectName = <label style={{fontStyle: 'italic', fontWeight: 'bold'}}>{project.title} *</label>;
    }

    const visibleOptions = options.filter(option => {
      const hideWhenLoggedOut = (
        option.id === PROJECT_EDIT_DETAILS ||
        option.id === PROJECT_CREATE_NEW ||
        option.id === PROJECT_REMOVE_REQUEST ||
        option.id === SETTINGS
      );
      return !(hideWhenLoggedOut && user.username === null);
    });

    return (
      <div className="nav-bar">
        <div className="m-container">
          { user.username ?
          <div className="project-dropdown">
              <label style={{fontStyle: 'normal'}}>{getUIText('PROJECTS-PROJECT_NAME', app.language, translations)}:</label>
            <div className="tab-item">
              <a className="tab-item-btn btn-edit-tab" onClick={e => {e.stopPropagation(); this.props.onOpenProjectDetails();}}>
                  <i className="fa fa-pencil"/>
                </a>
                {selectedProjectName}
              <a className="tab-item-btn btn-close-tab" onClick={e => {e.stopPropagation(); this.props.onRequestProjectRemove();}}>
                <i className="fa fa-close"/>
              </a>
            </div>
            <div
              className="opener"
              aria-owns={this.state.open ? 'project-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
            >
              <div className="opener-btn">
                <i className="fa fa-chevron-down"></i>
              </div>
            </div>

            <Menu
              id="project-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              onClose={this.handleRequestClose}
              style={{ zIndex: 1700 }}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              MenuListProps={{
                onClick: (event) => {
                  event.stopPropagation();
                },
                style: {
                  maxHeight: 400
                },
              }}
            >
              {projects ? projects.map((item, key) => {
                let projectName = <label style={{marginBottom: 0 + 'px'}}>{item.title}</label>;
                if(project.unsaved && item.id === project.id) {
                  projectName = <label style={{marginBottom: 0 + 'px', fontStyle: 'italic'}}>{item.title} *</label>;
                }

                return (<MenuItem
                  key={key}
                  button
                  selected={item.id === project.id}
                  onClick={this.handleProjectMenuItemClick(item, SELECT_PROJECT)}>
                    {projectName}
                  </MenuItem>);
              }) : null}
              <Divider />
              <MenuItem
                button
                onClick={this.handleProjectMenuItemClick(null, NEW_PROJECT)}
              >
                <span style={{fontWeight: 'bold'}}>{getUIText('PROJECTS-CREATE_NEW_PROJECT', app.language, translations)}</span>
              </MenuItem>
            </Menu>
          </div> : null }

          <div className="action-buttons">
            { user.username ? project ? project.unsaved ? <Button onClick={saveProject} variant="raised" color="primary">{getUIText('GENERAL-SAVE_PROJECT', app.language, translations)}</Button> : null : null : null}
            <IconButton
              aria-label="More"
              aria-owns={this.state.open2 ? 'long-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick2}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={this.state.anchorEl2}
              open={this.state.open2}
              onClose={this.handleRequestClose2}
              style={{
                maxHeight: ITEM_HEIGHT * (visibleOptions.length + 5),
                zIndex: 1700,
              }}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              MenuListProps={{
                style: {
                  width: 'auto',
                },
              }}
            >
              {visibleOptions.map(option => (
                <MenuItem
                  key={option.id}
                  selected={false}
                  onClick={this.handleActionMenuItemClick(option.id)}
                >
                  {getUIText(option.languageId, app.language, translations)}
                </MenuItem>
              ))}
            </Menu>
          </div>
          <TabBar />
        </div>
      </div>
    );
  }
}

NavBar.propTypes = {
    user: PropTypes.object,
    app: PropTypes.object,
    project: PropTypes.object,
    projects: PropTypes.array,
    translations: PropTypes.object,
  selectProject: PropTypes.any,
  closeDialog: PropTypes.any,
  openSaveProjectDialog: PropTypes.any,
  onOpenProjectDetails: PropTypes.any,
  openCreateNewProjectDialog: PropTypes.any,
  createPDF: PropTypes.any,
  history: PropTypes.any,
  openSetting: PropTypes.any,
  cloneCalculation: PropTypes.any,
  onCalculationRemove: PropTypes.any,
  onCalculatioRename: PropTypes.any,
  onRequestProjectRemove: PropTypes.any,
  onProjectNameChange: PropTypes.any,
  onCalculationIndexChange: PropTypes.any,
  saveProject: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        app: state.app,
        project: state.project,
        projects: state.projects,
        translations: state.translations,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onProjectNameChange: name => dispatch(patchProject({ name })),
        onCalculationIndexChange: index => dispatch(patchProject({ calculationIndex: index })),
        createPDF: () => dispatch(pdfCreateRequest()),
        selectProject: project => dispatch(selectProject(project)),
        cloneCalculation: () => {dispatch(cloneCalculation());},
        onCalculatioRename: index => dispatch(requestCalculationRename()),
        onCalculationRemove: index => dispatch(requestCalculationRemove()),
        onOpenProjectDetails: () => dispatch(openDialog({dialog: PROJECT_DETAILS_DIALOG})),
        openCreateNewProjectDialog: () => dispatch(openDialog({dialog: CREATE_NEW_PROJECT_DIALOG})),
        openSetting: () => dispatch(openSetting()),
        onRequestProjectRemove: () => dispatch(requestProjectRemove()),

        saveProject: () => dispatch(saveProject()),
        closeDialog: () => dispatch(closeDialog()),
        openSaveProjectDialog: (data) => dispatch(openDialog({dialog: PROJECT_SAVE_DIALOG, data: data})),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBar);
